<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Providers"
    :submit="submit" :status="status">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider ref="full_name" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.full_name" label="Nombre y Apellido"
                  prepend-inner-icon="fas fa-user"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="email" rules="required|email" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.email" label="E-mail"
                  prepend-inner-icon="fas fa-envelope"></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col>
              <ValidationProvider ref="password" rules="min:4" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.password" label="Password"
                  :type="show1 ? 'text' : 'password'" :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  @click:append="show1 = !show1" autocomplete="off" readonly
                  onfocus="this.removeAttribute('readonly');"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <label>Biografía</label>
              <ValidationProvider ref="bio" rules="" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.bio" solo rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="profile_picture" rules="" v-slot="{ errors }">
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Perfil" prepend-icon="fas fa-camera" label="" :multiple="false"
                  :onSelectedPicture="onSelectedPicture"></Upload>
                <v-img :src="profile_picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>

        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider ref="number" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.number" label="Número"
                  prepend-inner-icon="fas fa-number"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="type" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.type" label="Tipo"
                  prepend-inner-icon="fas fa-number"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="front_picture" rules="" v-slot="{ errors }">
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg" placeholder="Imagen Frontal"
                  prepend-icon="fas fa-camera" label="" :multiple="false" :onSelectedPicture="onSelectedFrontPicture">
                </Upload>
                <v-img :src="front_picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="back_picture" rules="" v-slot="{ errors }">
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg" placeholder="Imagen Trasera"
                  prepend-icon="fas fa-camera" label="" :multiple="false" :onSelectedPicture="onSelectedBackPicture">
                </Upload>
                <v-img :src="back_picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="address" rules="" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.address" label="Dirección"
                  prepend-inner-icon="fas fa-number"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="commercial_address" rules="" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.commercial_address" label="Dirección Comercial"
                  prepend-inner-icon="fas fa-number"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="commercial_name" rules="" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.commercial_name" label="Nombre de Comercio"
                  prepend-inner-icon="fas fa-number"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },

  data() {
    return {
      storeName: "Providers",
      title: "Proveedor",
      filteredAttributes: ["profile_picture", "front_picture", "back_picture"],
      show1: false,
      profile_picture: "",
      front_picture: "",
      back_picture: "",
      data: {
        full_name: "",
        email: "",
        password: "",
        profile_picture: undefined,
        number: "",
        type: "",
        front_picture: undefined,
        back_picture: undefined,
        bio: "",
        address: "",
        commercial_address: "",
        commercial_name: "",
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Providers.status,
      detail_providers: state => state.Detail_providers.list,
    }),
  },
  watch: {

  },
  async created() {
    const self = this;
    await self.$store.dispatch("Detail_providers/getListAll", { user_id: self.$route.params.id });

    self.data.type = self.detail_providers[0].type;
    self.data.number = self.detail_providers[0].number;
    self.back_picture = self.detail_providers[0].back_picture;
    self.front_picture = self.detail_providers[0].front_picture;
  },
  methods: {
    onSelectedPicture(file) {
      const self = this;
      this.data.profile_picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.profile_picture = fr.result;
      };
      fr.onerror = function () {
        self.profile_picture = '';
      };
      fr.readAsDataURL(this.data.profile_picture);
    },
    onSelectedFrontPicture(file) {
      const self = this;
      this.data.front_picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.front_picture = fr.result;
      };
      fr.onerror = function () {
        self.front_picture = '';
      };
      fr.readAsDataURL(this.data.front_picture);
    },
    onSelectedBackPicture(file) {
      const self = this;
      this.data.back_picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.back_picture = fr.result;
      };
      fr.onerror = function () {
        self.back_picture = '';
      };
      fr.readAsDataURL(this.data.back_picture);
    }
  },
};
</script>
